
<template>
  <div id="analyticLecture">
    <Header :title="$t('Header.ADMINISTRATOR')" logoutPath="/Backend/Login" />
    <Menu />

    <div class="pnlBEContent scrollBar">
      <TitleBar
        :iconSrc="require('@/assets/img/menu/icon_Courses_hover.png')"
        :title="$t('SAAnalyticLecture.PageName')"
      />

      <div class="pnlBESearchScroll">
        <div class="searchTools">
          <label class="lblSearchTitle">開始時間</label>
          <Datepicker
            format="yyyy-MM-dd"
            v-model="search.startDate"
            class="lblSearchDate"
            :placeholder="$t('SESGRecord.PlaceholderStartDate')"
            :disabled-dates="disableStartDates"
            @closed="OnStartDateSelectChange"
          ></Datepicker>
          <label class="lblSearchTitle">結束時間</label>
          <Datepicker
            format="yyyy-MM-dd"
            v-model="search.endDate"
            class="lblSearchDate"
            :placeholder="$t('SESGRecord.PlaceholderEndDate')"
            :disabled-dates="disableEndDates"
          ></Datepicker>

          <button class="btnWidthIcon iconSearch" @click="SearchInfo">
            {{ $t('SESGRecord.BtnSearch') }}
          </button>
          <button class="btnWidthIcon iconDownload" @click="DownloadFile" v-if="analyticData.length != 0">
            {{ $t('SESGRecord.RecordDownload') }}
          </button>
        </div>
        <div style="clear: both"></div>
        <table id="tableLecture" class="AnalyticLectureTable">
          <tr>
            <th>縣市</th>
            <th>學校</th>
            <th>使用總時數</th>
            <th>使用總次數</th>
            <th>課程</th>
            <th></th>
            <th>時數</th>
            <th>次數</th>
          </tr>
          <template v-for="school in analyticData">
            <template v-for="(lecture, lectureIndex) in school.lectures">
              <tr
                v-for="(subLecture, subLectureIndex) in lecture.subLectures"
                :key="school.county + school.school + lecture.lecture + subLecture.subLecture"
              >
                <td :rowspan="CalcSchoolRowspan(school.lectures)" v-if="CalcSchoolShow(lectureIndex, subLectureIndex)">
                  {{ school.county }}
                </td>
                <td :rowspan="CalcSchoolRowspan(school.lectures)" v-if="CalcSchoolShow(lectureIndex, subLectureIndex)">
                  {{ school.school }}
                </td>
                <td :rowspan="CalcSchoolRowspan(school.lectures)" v-if="CalcSchoolShow(lectureIndex, subLectureIndex)">
                  {{ school.totalTime }}
                </td>
                <td :rowspan="CalcSchoolRowspan(school.lectures)" v-if="CalcSchoolShow(lectureIndex, subLectureIndex)">
                  {{ school.totalNumber }}
                </td>
                <td :rowspan="CalcLectureRowspan(lecture.subLectures)" v-if="CalcLectureShow(subLectureIndex)">
                  {{ lecture.lecture }}
                </td>
                <td>{{ subLecture.subLecture }}</td>
                <td>{{ subLecture.useTime }}</td>
                <td>{{ subLecture.useNumber }}</td>
              </tr>
            </template>
          </template>
          <tr v-if="analyticData.length == 0">
            <td colspan="8">此篩選條件查無資料，請更改篩選條件。</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Backend/Menu.vue';
import TitleBar from '@/components/TitleBar.vue';
import Datepicker from 'vuejs-datepicker';
import { apiGetAnalyticLecture } from '@/request.js';

export default {
  data() {
    return {
      search: {
        startDate: new Date(),
        endDate: new Date(),
      },
      analyticData: [],
    };
  },
  computed: {
    disableStartDates: function () {
      return { from: new Date() };
    },
    disableEndDates: function () {
      var dtStart = new Date(this.search.startDate);
      dtStart.setDate(dtStart.getDate() + parseInt(1));
      return { to: dtStart, from: this.tomorrow };
    },
    tomorrow: function () {
      let tomorrowDate = new Date();
      tomorrowDate.setDate(tomorrowDate.getDate() + parseInt(1));
      return tomorrowDate;
    },
  },
  mounted() {
    this.search.endDate = this.tomorrow;
    this.SearchInfo();
  },
  methods: {
    CalcSchoolRowspan(lectures) {
      let spanNum = 0;
      for (let i = 0; i < lectures.length; i++) {
        spanNum += lectures[i].subLectures.length;
      }
      return spanNum;
    },
    CalcLectureRowspan(subLectures) {
      return subLectures.length;
    },
    CalcSchoolShow(lectureIndex, subLectureIndex) {
      return lectureIndex == 0 && subLectureIndex == 0 ? true : false;
    },
    CalcLectureShow(subLectureIndex) {
      return subLectureIndex == 0 ? true : false;
    },
    OnStartDateSelectChange() {
      let dtStart = new Date(this.search.startDate);
      let dtEnd = new Date(this.search.endDate);
      if (dtStart >= dtEnd) {
        dtStart.setDate(dtStart.getDate() + parseInt(1));
        this.search.endDate = dtStart;
      }
    },
    SearchInfo() {
      let startDate = this.GetDateFormat(this.search.startDate);
      let endDate = this.GetDateFormat(this.search.endDate);
      //console.log(`startDate: ${startDate} ,endDate: ${endDate} `);

      let data = {
        startdate: startDate,
        enddate: endDate,
        school: localStorage.getItem('school'),
      };
      apiGetAnalyticLecture(data).then((res) => {
        //console.log(JSON.stringify(res.data.analyticData));
        if (res.data.analyticData != null) {
          this.analyticData = res.data.analyticData;
        } else {
          this.analyticData = [];
        }
      });

      // this.analyticData = [
      //   {
      //     county: '高雄市',
      //     school: '民權國小',
      //     totalTime: '50S',
      //     totalNumber: 20,
      //     lectures: [
      //       {
      //         lecture: '教具酷',
      //         subLectures: [
      //           { subLecture: '細胞的基本構造', useTime: '50S', useNumber: '2' },
      //           { subLecture: '滲透作用', useTime: '50S', useNumber: '2' },
      //           { subLecture: 'AA作用', useTime: '50S', useNumber: '2' },
      //         ],
      //       },
      //       {
      //         lecture: '英語小鬥士',
      //         subLectures: [{ subLecture: '-', useTime: '50S', useNumber: '2' }],
      //       },
      //       {
      //         lecture: '化學實驗酷',
      //         subLectures: [{ subLecture: '-', useTime: '50S', useNumber: '2' }],
      //       },
      //     ],
      //   },
      //   {
      //     county: '高雄市',
      //     school: 'B國小',
      //     totalTime: '50S',
      //     totalNumber: 20,
      //     lectures: [
      //       {
      //         lecture: '英語小鬥士',
      //         subLectures: [{ subLecture: '-', useTime: '50S', useNumber: '2' }],
      //       },
      //     ],
      //   },
      // ];
    },
    GetDateFormat(date) {
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    },
    DownloadFile() {
      //globalFunction.js
      this.ExportExcel('tableLecture');
    },
  },
  components: {
    Header,
    Menu,
    TitleBar,
    Datepicker,
  },
};
</script>
